import { render } from "./NodePermission.vue?vue&type=template&id=46dd3675&scoped=true"
import script from "./NodePermission.vue?vue&type=script&lang=js"
export * from "./NodePermission.vue?vue&type=script&lang=js"

import "./NodePermission.vue?vue&type=style&index=0&id=46dd3675&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dd3675"]])

export default __exports__